<template>
    <div
      	class="form-group"
		:id="id || null"
		:class="{[classe]: classe}"
		>
        <div
          v-for="option in options"
          :key="option.id"
          class="distribution btn btn-light mr-1"
          :class="{'active': selectedValue === option.id}"
          @click="selectButton(option)"
          data-toggle="tooltip"
          data-placement="top"
          :title="option.tooltip"
        >
          <img :src="option.asset" :alt="option.alt" width="50" height="50" />
        </div>

		<div class="invalid-feedback d-block" v-if="error">
            {{ error }}
        </div>

        <input type="hidden" :value="selectedValue" name="distribution_clicks" />
    </div>
  </template>

  <script>
  export default {
    props: {
        value: { type: Number, required: false },
        options: { type:Array, required:true},
		error: { type: String, default: '', required: false },
        id: { type: String, default: '', required: false },
        classe: { type: String, default: '', required: false}
    },
    data() {
        return {
            selectedValue: this.value || 300,
        }
    },
    methods: {
        selectButton(option) {
            this.selectedValue = option.id;
            this.$emit("input", option.id);
        },
    },
  };
  </script>

  <style scoped type="scss">
    .btn-light:focus, .btn-light.focus {
        box-shadow: none;
    }
    .btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {
        box-shadow: none!important;
    }
  </style>

